// @flow

import type { SpecialContactsTypesState } from "./types";

export const initialState: SpecialContactsTypesState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  current: null,
  modals: {
    showTypeModal: false,
    showDeleteModal: false,
  },
};

export default initialState;
